module.exports = {
          srcSet: __webpack_public_path__ + "img/1a6e86f-4032.jpg"+" 4032w",
          images:[ {path: __webpack_public_path__ + "img/1a6e86f-4032.jpg",width: 4032,height: 3024}],
          src: __webpack_public_path__ + "img/1a6e86f-4032.jpg",
          toString:function(){return __webpack_public_path__ + "img/1a6e86f-4032.jpg"},
          
          width: 4032,
          height: 3024
        }